export enum CollectionEvent {
  addCollection = 'addCollection',
  deleteCollection = 'deleteCollection',
}
